import styled, { css } from 'styled-components';

const defaultWrapperWidth = '498px';

export const Form = styled.form`
  ${({ theme }) => css`
    font-family: ${theme.v2.font.family.primary};

    strong {
      font-weight: ${theme.v2.font.weights.medium};
    }
  `};
`;

export const InputsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 24px;
  margin: 24px 0px 24px;
  max-width: ${defaultWrapperWidth};

  div {
    width: 100%;
  }
`;

export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const RadioQuestionTitle = styled.label`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: 16px;
    font-weight: ${theme.v2.font.weights.medium};
  `};
`;

export const Info = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin: 24px 0px 24px;
    max-width: 100%;
    color: #363636;
    font-size: 16px;
    line-height: 24px;

    > div:first-child {
      display: flex;
      flex-direction: row;
      gap: 8px;
      align-items: center;

      svg {
        width: 24px;
        height: 24px;
      }
    }

    strong {
      font-weight: ${theme.v2.font.weights.medium};
      font-size: 16px;
      line-height: 24px;
      color: #363636;
    }

    > div:last-child {
      padding: 0 24px;
    }

    p {
      margin: 0;
      padding: 0;
      font-size: 16px;
      line-height: 24px;
      font-weight: 400;
      color: #363636;
      white-space: pre-line;
    }
  `}
`;

export const Title = styled.h2`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: 18px;
    font-weight: ${theme.v2.font.weights.medium};
    line-height: 27px;
    margin: 24px 0px 0px;
    max-width: ${defaultWrapperWidth};
  `}
`;

export const FieldInfo = styled.span`
  ${({ theme }) => css`
      display: block;
      flex-direction: row;
      font-size: ${theme.v2.font.sizes.xxxs};
      font-weight: ${theme.v2.font.family.regular};
      margin: 0px;
      max-width: ${defaultWrapperWidth};
      color: ${theme.v2.colors.neutral.lowLight};
  `}
`;

export const ButtonWrapper = styled.div`
  button {
    max-height: 35px;
  }
`;


export const CheckboxLabel = styled.label`
  align-items: center;
  cursor: pointer;
  display: inline-flex;
  margin: 0px;

  label {
    width: 19px;
    height: 19px;
  }
`;

export const RadioLabel = styled.label`
  align-items: center;
  cursor: pointer;
  display: inline-flex;
  margin: 0px;

  label {
    width: 19px;
    height: 19px;
  }
`;

export const Text = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    display: inline-block;
    font-size:  ${theme.v2.font.sizes.xxs};
    gap: 6px;
    line-height: ${theme.v2.font.lineHeight.text};

    a {
      font-size:  ${theme.v2.font.sizes.xxs};
    }
  `}
`;
